
@if (url) {
  <div class="video">
    <video autoplay  controls>
      <source [src]="url" type="video/mp4">
    </video>
  </div>
}